import { Box, Heading, Flex, Link } from "@chakra-ui/react"
import React from "react"
import { colors } from "../colors/colors"
import { Raw } from "../section/RawContent"
import { Image } from "../image/Image"

export function MobileCard({
  title,
  titleFontSize = `16px`,
  titleColor = "#000000",
  content,
  author,
  overrideAuthor,
}) {
  return (
    <Box
      p="20px"
      bg={`white`}
      boxShadow={`0 0 16px 0 rgba(0,0,0,0.15)`}
      borderRadius="10px"
    >
      <Heading
        as="h3"
        fontSize={titleFontSize}
        letterSpacing="-0.47px"
        lineHeight="29px"
        m={0}
        color={titleColor}
        textTransform="uppercase"
        textAlign="left"
        fontWeight={600}
      >
        {title}
      </Heading>

      <Box mt="15px">
        <Raw content={content} />
      </Box>

      <Heading
        as="h3"
        fontSize="16px"
        letterSpacing="-0.47px"
        lineHeight="29px"
        m={0}
        color={colors.blue}
        textTransform="uppercase"
        textAlign="left"
        fontWeight={600}
      >
        {overrideAuthor ? overrideAuthor : author}
      </Heading>
    </Box>
  )
}

export function TileCard({
  onClick,
  display,
  title,
  titleFontSize = `20px`,
  titleColor = "#000000",
  subtitle,
  image,
  link,
  bgColor,
  clickable,
  textboxPadding = `22px 20px`,
  overrideGridColumn,
  gridColumn,
  showContent,
  content,
  descriptionProps = {},
  ...rest
}) {
  const inner = (
    <Box
      css={{
        "&:focus": {
          ".overlay": {
            display: "none",
          },
        },
        ".descriptions": {
          backgroundColor: showContent ? colors.blue10 : colors.bggray,
        },
        "&:hover": {
          ".overlay": {
            display: "block",
            backgroundColor: showContent ? colors.blue10 : bgColor,
          },
          ".descriptions": {
            backgroundColor: showContent ? colors.blue10 : bgColor,
          },
        },
      }}
      display={{
        base: display?.base,
        sm: display?.sm,
        md: display?.md,
        lg: display?.lg,
        xl: display?.xl,
      }}
      onClick={onClick}
      gridColumn={
        gridColumn || {
          base: `span 6`,
          sm: `span 2`,
          md: `span 4`,
          lg: overrideGridColumn || `span 3`,
        }
      }
      className="ABHI"
      {...rest}
    >
      <Box
        maxWidth={`100%`}
        height={{ base: `auto`, md: `220px`, lg: `220px` }}
        overflow="hidden"
        zIndex={{ lg: 1 }}
        position="relative"
      >
        {image?.node?.localFile?.childImageSharp && (
          <Image image={image.node.localFile} />
        )}
        {!showContent && (
          <Box
            className="overlay"
            bg={bgColor}
            position="absolute"
            display="none"
            height="100%"
            width="100%"
            top="0"
            left="0"
            zIndex={{ base: 1, lg: 2 }}
          ></Box>
        )}
      </Box>

      <Flex
        className="descriptions"
        flexWrap={{ base: `wrap`, lg: `nowrap` }}
        zIndex={3}
        {...descriptionProps}
      >
        <Box flexBasis="100%" p={textboxPadding} textAlign="left">
          <Heading
            as="h3"
            fontSize={titleFontSize}
            lineHeight="29px"
            m={0}
            color={titleColor}
            textTransform="uppercase"
            textAlign="left"
            fontWeight={600}
          >
            {title}
          </Heading>
          <Heading
            as="p"
            color={colors.blue}
            fontSize={16}
            textTransform="uppercase"
            m={0}
            lineHeight="20px"
            fontWeight={600}
          >
            {link ? (
              <Link href={link} target="_blank">
                {subtitle}
              </Link>
            ) : (
              subtitle
            )}
          </Heading>
          {showContent && (
            <Box mt="15px">
              <Raw content={content} />
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  )

  if (clickable && link) {
    return (
      <Link href={link} target="_blank" _hover={{ textDecoration: `none` }}>
        {inner}
      </Link>
    )
  }

  return inner
}

export function TileCardWithDescription(props) {
  return (
    <TileCard
      showContent
      textboxPadding={`26px 21px`}
      titleFontSize={"26px"}
      gridColumn={{
        base: `span 6`,
        sm: `span 4`,
        md: `2 / span 6`,
        lg: props.overrideGridColumn || `span 3`,
      }}
      descriptionProps={{
        minHeight: { base: `auto`, md: `340px` },
        maxHeight: { base: `auto`, md: `340px` },
      }}
      {...props}
    />
  )
}
